import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import SpacialOffer from "./SpacialOffer";
import RelatedProduct from "./RelatedProduct";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const SingleProduct = () => {
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState("S");
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  const productImages = [
    { large: "assets/images/single-product/large-size/1.jpg", small: "assets/images/single-product/small-size/1.jpg" },
    { large: "assets/images/single-product/large-size/2.jpg", small: "assets/images/single-product/small-size/2.jpg" },
    { large: "assets/images/single-product/large-size/3.jpg", small: "assets/images/single-product/small-size/3.jpg" },
    { large: "assets/images/single-product/large-size/4.jpg", small: "assets/images/single-product/small-size/4.jpg" },
    { large: "assets/images/single-product/large-size/5.jpg", small: "assets/images/single-product/small-size/5.jpg" },
    { large: "assets/images/single-product/large-size/6.jpg", small: "assets/images/single-product/small-size/6.jpg" },
  ];

  const sizes = ["S", "M", "L", "XL"];

  const increaseQty = () => setQuantity(prev => prev + 1);
  const decreaseQty = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));
 

  // ADD TO CART FUNCTION
  const addToCart = () => {
    const product = {
      id: 1, // ideally use product ID from props/data
      name: "JWDA Penant Lamp Brshed Steel",
      price: 453.35,
      image: productImages[0].small,
      quantity,
      size: selectedSize
    };

    const existingItem = cartItems.find(
      (item) => item.id === product.id && item.size === selectedSize
    );

    if (existingItem) {
      setCartItems(
        cartItems.map((item) =>
          item.id === product.id && item.size === selectedSize
            ? { ...item, quantity: item.quantity + quantity }
            : item
        )
      );
    } else {
      setCartItems([...cartItems, product]);
    }

    setCartOpen(true); // open mini-cart
  };

  const removeFromCart = (id, size) => {
    setCartItems(cartItems.filter(item => !(item.id === id && item.size === size)));
  };
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-area">
        <div className="container">
          <div className="breadcrumb-content">
            <h2>Single Product Type</h2>
            <ul>
              <li><a href="/">Home</a></li>
              <li className="active">Single Product</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Single Product Area */}
      <div className="sp-area">
        <div className="container">
          <div className="sp-nav row">
            {/* Product Images */}
            <div className="col-lg-5 col-md-5">
              <div className="sp-img_area">
                <div className="zoompro-border">
                  <Swiper
                    modules={[Navigation, Thumbs]}
                    thumbs={{ swiper: thumbsSwiper }}
                    
                    className="sp-main-slider"
                  >
                    {productImages.map((img, idx) => (
                      <SwiperSlide key={idx}>
                        <img
                          className="zoompro"
                          src={img.large}
                          data-zoom-image={img.large}
                          alt="Hiraola's Product Image"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={10}
                  slidesPerView={4}
                  freeMode
                  watchSlidesProgress
                  className="sp-img_slider mt-3"
                >
                  {productImages.map((img, idx) => (
                    <SwiperSlide key={idx}>
                      <img src={img.small} alt="Thumbnail" />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            {/* Product Info */}
            <div className="col-lg-7 col-md-7">
              <div className="sp-content">
                <div className="sp-heading">
                  <h5><a href="#">JWDA Penant Lamp Brshed Steel</a></h5>
                </div>
                <span className="reference">Reference: demo_1</span>

                <div className="rating-box">
                  <ul>
                    {Array(4).fill(0).map((_, i) => <li key={i}><i className="fa fa-star-of-david"></i></li>)}
                    <li className="silver-color"><i className="fa fa-star-of-david"></i></li>
                  </ul>
                </div>

                <div className="sp-essential_stuff">
                  <ul>
                    <li>EX Tax: <span>£453.35</span></li>
                    <li>Brands Buxton</li>
                    <li>Product Code: Product 16</li>
                    <li>Reward Points: 600</li>
                    <li>Availability: In Stock</li>
                  </ul>
                </div>

                {/* Size Selector */}
                <div className="product-size_box">
                  <span>Size</span>
                  <select
                    className="myniceselect"
                    value={selectedSize}
                    onChange={(e) => setSelectedSize(e.target.value)}
                  >
                    {sizes.map((size, idx) => (
                      <option key={idx} value={size}>{size}</option>
                    ))}
                  </select>
                </div>

                {/* Quantity */}
                <div className="quantity">
                  <label>Quantity</label>
                  <div className="cart-plus-minus">
                    <div className="dec qtybutton" onClick={decreaseQty}><i className="fa fa-angle-down"></i></div>
                    <input className="cart-plus-minus-box" type="text" value={quantity} readOnly />
                    <div className="inc qtybutton" onClick={increaseQty}><i className="fa fa-angle-up"></i></div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="qty-btn_area">
                  <ul>
                    <li><a className="qty-cart_btn" href="#">Add To Cart</a></li>
                    <li><a className="qty-wishlist_btn" href="#"><i className="ion-android-favorite-outline"></i></a></li>
                    <li><a className="qty-compare_btn" href="#"><i className="ion-ios-shuffle-strong"></i></a></li>
                  </ul>
                </div>

                {/* Tags */}
                <div className="hiraola-tag-line">
                  <h6>Tags:</h6>
                  <a href="#">Ring</a>, <a href="#">Necklaces</a>, <a href="#">Braid</a>
                </div>

                {/* Social Links */}
                <div className="hiraola-social_link">
                  <ul>
                    <li className="facebook"><a href="#"><i className="fab fa-facebook"></i></a></li>
                    <li className="twitter"><a href="#"><i className="fab fa-twitter-square"></i></a></li>
                    <li className="youtube"><a href="#"><i className="fab fa-youtube"></i></a></li>
                    <li className="google-plus"><a href="#"><i className="fab fa-google-plus"></i></a></li>
                    <li className="instagram"><a href="#"><i className="fab fa-instagram"></i></a></li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="hiraola-product-tab_area-2 sp-product-tab_area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="sp-product-tab_nav ">
                                <div className="product-tab">
                                    <ul className="nav product-menu" role="tablist">
                                        <li><a className="active" data-bs-toggle="tab" href="#description" aria-selected="true" role="tab"><span>Description</span></a>
                                        </li>
                                        <li><a data-bs-toggle="tab" href="#specification" aria-selected="false" tabIndex={1} role="tab"><span>Specification</span></a></li>
                                        <li><a data-bs-toggle="tab" href="#reviews" aria-selected="false" tabIndex={1} role="tab"><span>Reviews (1)</span></a></li>
                                    </ul>
                                </div>
                                <div className="tab-content hiraola-tab_content">
                                    <div id="description" className="tab-pane active show" role="tabpanel">
                                        <div className="product-description">
                                            <ul>
                                                <li>
                                                    <strong>Karat Gold</strong>
                                                    <span>24K gold is called pure gold or fine gold. (99.99% pure) The color of fine
                                                        gold is a bright yellow with a bit of orange. Some say it is too soft for
                                                        jewelry application, but high karat gold is commonly worn in some parts of
                                                        the world, and it is growing in popularity in designer jewelry. Most will
                                                        prefer karat golds for their engagement rings, because of the needed
                                                        hardness to hold a gemstone.</span>
                                                </li>
                                                <li>
                                                    <strong>Gold Colors</strong>
                                                    <span>The most popular color is yellow which is made by adding silver and some
                                                        copper. The metals are melted together to form an alloy of the desired color
                                                        and karat. It is very important that all the ingredients are pure and that
                                                        the amounts of each are weighed very accurately to prevent porosity, which
                                                        weakens the alloy.</span>
                                                </li>
                                                <li>
                                                    <strong>White alloys</strong>
                                                    <span>There are two kinds of White Gold: Nickel based and Palladium based. Some
                                                        people are allergic to Nickel, so Palladium white gold is a good
                                                        alternative. Palladium white gold is the only legal alloy in Europe. It also
                                                        self burnishes and keeps a polish.</span>
                                                </li>
                                                <li>
                                                    <strong>The Most Expensive Diamond Color</strong>
                                                    <span>D colored diamonds are the rarest and most expensive of diamonds within
                                                        the D-Z scale. Certain fancy colored diamonds will command the highest
                                                        prices overall, and these will be discussed in separate tutorial. Many
                                                        people enjoy diamonds in the near colorless range G-J, as they find a
                                                        balance of size, clarity, and price to meet their needs.</span>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                    <div id="specification" className="tab-pane" role="tabpanel">
                                        <table className="table table-bordered specification-inner_stuff">
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2}><strong>Memory</strong></td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr>
                                                    <td>test 1</td>
                                                    <td>8gb</td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2}><strong>Processor</strong></td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr>
                                                    <td>No. of Cores</td>
                                                    <td>1</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="reviews" className="tab-pane" role="tabpanel">
                                        <div className="tab-pane active" id="tab-review">
                                            <form className="form-horizontal" id="form-review">
                                                <div id="review">
                                                    <table className="table table-striped table-bordered">
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: "50%" }}><strong>Customer</strong></td>
                                                                <td className="text-right">25/04/2022</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2}>
                                                                    <p>Good product! Thank you very much</p>
                                                                    <div className="rating-box">
                                                                        <ul>
                                                                            <li><i className="fa fa-star-of-david"></i></li>
                                                                            <li><i className="fa fa-star-of-david"></i></li>
                                                                            <li><i className="fa fa-star-of-david"></i></li>
                                                                            <li><i className="fa fa-star-of-david"></i></li>
                                                                            <li><i className="fa fa-star-of-david"></i></li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <h2>Write a review</h2>
                                                <div className="form-group required">
                                                    <div className="col-sm-12 p-0">
                                                        <label>Your Email <span className="required">*</span></label>
                                                        <input className="review-input" type="email" name="con_email" id="con_email" required="" />
                                                    </div>
                                                </div>
                                                <div className="form-group required second-child">
                                                    <div className="col-sm-12 p-0">
                                                        <label className="control-label">Share your opinion</label>
                                                        <textarea className="review-textarea" name="con_message" id="con_message"></textarea>
                                                        <div className="help-block"><span className="text-danger">Note:</span> HTML is not
                                                            translated!</div>
                                                    </div>
                                                </div>
                                                <div className="form-group last-child required">
                                                    <div className="col-sm-12 p-0">
                                                        <div className="your-opinion">
                                                            <label>Your Rating</label>
                                                            <span>
                                                                <div className="br-wrapper br-theme-fontawesome-stars"><select className="star-rating" style={{ display: "none" }}>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </select><div className="br-widget"><a href="#" data-rating-value="1" data-rating-text="1" className="br-selected br-current"></a><a href="#" data-rating-value="2" data-rating-text="2"></a><a href="#" data-rating-value="3" data-rating-text="3"></a><a href="#" data-rating-value="4" data-rating-text="4"></a><a href="#" data-rating-value="5" data-rating-text="5"></a><div className="br-current-rating">1</div></div></div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="hiraola-btn-ps_right">
                                                        <a href="javascript:void(0)" className="hiraola-btn hiraola-btn_dark">Continue</a>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          <SpacialOffer/>
          <RelatedProduct />

    </>
  );
};

export default SingleProduct;
